var swiper = new Swiper(".mySwiper-announce", {
  spaceBetween: 8,
  slidesPerView: "auto",
  loop: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 10000,
  grabCursor: false,
  mousewheelControl: false,
  //   breakpoints: {
  //     315: {
  //       slidesPerView: 2,
  //     },
  //     768: {
  //       slidesPerView: 2.5,
  //     },
  //     1024: {
  //       slidesPerView: 4.5,
  //     },
  //   },
});

document.addEventListener("DOMContentLoaded", function () {
  const formatMoney = function (cents, format) {
    if (cents === null || cents === undefined || Number.isNaN(Number(cents))) {
      return "";
    }

    const amount = Number(cents);
    const moneyFormat = format || "${{amount}}";
    let placeholder = "amount";

    const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (placeholderMatch && placeholderMatch[1]) {
      placeholder = placeholderMatch[1];
    }

    const formatWithDelimiters = function (
      number,
      precision,
      thousands,
      decimal
    ) {
      const value = (number / 100).toFixed(precision);
      const parts = value.split(".");
      const dollars = parts[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousands || ","
      );
      const centsPart = parts[1] ? (decimal || ".") + parts[1] : "";

      return dollars + centsPart;
    };

    let value = "";
    switch (placeholder) {
      case "amount":
        value = formatWithDelimiters(amount, 2, ",", ".");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(amount, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(amount, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(amount, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(amount, 2, ",", ".");
        break;
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  };

  const input = document.getElementById("quantity");
  const decreaseBtn = document.querySelector(".decrease");
  const increaseBtn = document.querySelector(".increase");

  if (input && decreaseBtn && increaseBtn) {
    decreaseBtn.addEventListener("click", function () {
      let currentValue = parseInt(input.value);
      if (currentValue > 1) {
        // ตรวจสอบไม่ให้ลดต่ำกว่า 1
        input.value = currentValue - 1;
      }
    });

    increaseBtn.addEventListener("click", function () {
      let currentValue = parseInt(input.value);
      input.value = currentValue + 1;
    });
  }

  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach(function (form) {
    const optionSelects = form.querySelectorAll(".variant-option-select");
    const variantIdInput = form.querySelector('input[name="id"]');
    const variantsJsonElement = form.querySelector(".product-variants-json");
    const addToCartButton = form.querySelector(".btn-atc");
    const buyItNowButton = form.querySelector("#buy-it-now");
    const productRight = form.closest(".right");
    const priceWrapper = productRight
      ? productRight.querySelector("[data-price-wrapper]")
      : null;
    const comparePriceElement = priceWrapper
      ? priceWrapper.querySelector("[data-compare-price]")
      : null;
    const currentPriceElement = priceWrapper
      ? priceWrapper.querySelector("[data-current-price]")
      : null;
    const moneyFormat = priceWrapper
      ? priceWrapper.getAttribute("data-money-format")
      : null;

    if (!optionSelects.length || !variantIdInput || !variantsJsonElement) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonElement.textContent);
    } catch (error) {
      return;
    }

    const findMatchingVariant = function () {
      const selectedOptions = Array.from(optionSelects).map(function (select) {
        return select.value;
      });

      return variants.find(function (variant) {
        return selectedOptions.every(function (value, index) {
          return variant["option" + (index + 1)] === value;
        });
      });
    };

    const syncVariant = function () {
      const matchedVariant = findMatchingVariant();

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;

        if (addToCartButton) {
          addToCartButton.disabled = !matchedVariant.available;
        }
        if (buyItNowButton) {
          buyItNowButton.disabled = !matchedVariant.available;
        }

        if (priceWrapper && currentPriceElement) {
          const hasPrice = Number.isFinite(Number(matchedVariant.price));
          const hasComparePrice =
            matchedVariant.compare_at_price &&
            matchedVariant.compare_at_price > matchedVariant.price;

          priceWrapper.hidden = !hasPrice;

          if (hasPrice) {
            currentPriceElement.textContent = formatMoney(
              matchedVariant.price,
              moneyFormat
            );
            currentPriceElement.classList.toggle("not-compare", !hasComparePrice);
          }

          if (comparePriceElement) {
            comparePriceElement.hidden = !hasComparePrice;
            comparePriceElement.textContent = hasComparePrice
              ? formatMoney(matchedVariant.compare_at_price, moneyFormat)
              : "";
          }
        }
        return;
      }

      variantIdInput.value = "";
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
      if (buyItNowButton) {
        buyItNowButton.disabled = true;
      }
      if (priceWrapper) {
        priceWrapper.hidden = true;
      }
    };

    optionSelects.forEach(function (select) {
      select.addEventListener("change", syncVariant);
    });

    syncVariant();
  });
});

(function ($) {
  $(".accordion > .accordion-item:first-child .accordion-head")
    .addClass("active")
    .next()
    .slideDown();

  $(".accordion .accordion-head").click(function (j) {
    var dropDown = $(this)
      .closest(".accordion-item")
      .find(".accordion-content");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this)
        .closest(".accordion")
        .find(".accordion-head.active")
        .closest(".accordion-item")
        .find(".accordion-content")
        .slideUp();
      $(this)
        .closest(".accordion")
        .find(".accordion-head.active")
        .removeClass("active");
      $(this).addClass("active");
    }

    dropDown.stop(false, true).slideToggle();

    j.preventDefault();
  });
})(jQuery);
